import * as React from 'react';
import { AuthButton, Button } from './Button';
import './PlaceListBulkBar.css';

interface PlaceListBulkBarProps {
  selectedCount: number;
  actionLabel: string;
  disabled: boolean;
  onAction: () => void;
  onDelete: () => void;
}

// 物件一覧で物件を選んでいる間だけ、絞り込みボタンの行にページへ重ねて出す、まとめて操作するためのバー。件数は左、操作は右に置く。
// アーカイブの付け外しは取り消せる操作なので白にし、赤は取り消せない削除だけに使って、2つを色で見分けられるようにする。
// 削除は物件を消す操作で、サーバーが権限の段階2以上でしか受け付けないので、その権限がある人にだけ出す
export const PlaceListBulkBar: React.FC<PlaceListBulkBarProps> = function (props) {
  return (
    <div className="PlaceListBulkBar-anchor">
      <div className="PlaceListBulkBar-container">
        <span className="PlaceListBulkBar-count">{props.selectedCount} 件選択中</span>
        <div className="PlaceListBulkBar-actions">
          <Button color="white" mini disabled={props.disabled} onClick={() => props.onAction()}>
            {props.actionLabel}
          </Button>
          <AuthButton authLv={2} color="red" mini disabled={props.disabled} onClick={() => props.onDelete()}>
            削除
          </AuthButton>
        </div>
      </div>
    </div>
  );
};
